import { Component } from "react"

class HomePage extends Component{
    constructor(props){
        super(props)
        this.name = "ホームページ"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 100){
                callbackDialog("エラー",this.name + "は100文字以内にしてください。")
                return false
            }
        }
        return true
    }
}

export default HomePage;